import LayoutNoMenu from '@/layout/defaultNoMenu';
const projectRouter = {
  path: '/project',
  name: 'project',
  component: LayoutNoMenu,
  children: [
      {
          path: 'update/detail/:id', 
          name: 'update_detail',
          component: () => import('@/views/project/update/_id.vue')
      },
    {
      path: 'protocal/:fater_id/:son_id',
      name: 'project_protocal',
      component: () => import('@/views/project/protocal/_id.vue')
    },
  ]
}
export default projectRouter;
